export enum PlatformAlertSeverity {
  Info = "Info",
  Alert = "Alert",
  Emmergency = "Emmergency",
}
